import React, { useContext, useEffect, useState, useRef } from "react";
import TaskEditDocumentModal from "../../task-edit-document-modal";
import DocumentViewer from "../../../../../components/documentViewer/documentViewer";
import DocumentViewerPowerpoint from "../../../../../components/documentViewerPowerpoint/documentViewerPowerpoint";
import TaskReopenPanel from "../../task-reopen-panel/task-reopen-panel";
import TaskCustomStatusPanelLegacy from "../../task-custom-status-panel/task-custom-status-panel-legacy";
import TaskCustomStatusPanel from "../../task-custom-status-panel/task-custom-status-panel";
import TasksActionsPanelNew from "../../tasks-actions-panel/tasks-actions-panel-new";
import TasksCommentsPanelNew from "../../tasks-comments-panel/tasks-comments-panel-new";
import TasksReassignPanel from "../../tasks-reassign-panel/tasks-reassign-panel";
import {
  DownloadFile,
  getTaskWithWorkflow,
} from "../../../../../services/api/task-api";
import { saveAs } from "file-saver";
import {
  viewWordDocument,
  viewPowerpointDocument,
  excelDocumentActions,
} from "../../../../../redux/tasks/task-actions";
import { OLD_UI_URL } from "../../../../../services/api/api-client";
import ActionsDropdownNew2 from "../common-components/actionsDropdownNew2";
import { LoginContext } from "../../../../../services/api/authentication-api";
import { useHistory } from "react-router-dom";
import "../../../../../components/actions-dropdown/actionsDropdown.scss";
import PropTypes from "prop-types";

export const TaskActions = ({
  taskId,
  refreshTasks,
  setTaskWorkflow = () => {},
  fromTaskEdit = false,
}) => {
  const { currentUser, userID } = useContext(LoginContext);
  let labels = currentUser?.objectLabels;
  let history = useHistory();
  const workflowCache = useRef({});

  const [model, setModel] = useState({
    showEditDCTaskModal: false,
    showDocumentViewer: false,
    showDocumentViewerPowerpoint: false,
    showReassignPanel: false,
    showReOpenPanel: false,
    showCustomStatusPanel: false,
    showAuditTrail: false,
    showActionsPanel: false,
  });
  const [docNameForDCTaskModal, setDocNameForDCTaskModal] = useState("");
  const [userActionType, setUserActionType] = useState("");
  const [actionsPanelType, setActionsPanelType] = useState("");
  const [documentViewerType, setDocumentViewerType] = useState("");
  const [customStatusID, setCustomStatusID] = useState("");
  const [customStatusAction, setCustomStatusAction] = useState("Normal");
  const [customActionID, setCustomActionID] = useState("");
  const [customActionName, setCustomActionName] = useState("");
  const [dataItem, setDataItem] = useState({});

  const getWorkflowButtons = async () => {
    let result;
    if (!fromTaskEdit && workflowCache.current[taskId]) {
      result = workflowCache.current[taskId];
    } else {
      result = await getTaskWithWorkflow(taskId);
      workflowCache.current[taskId] = { ...result, isWorkflow: true };
      setTaskWorkflow({ ...result, isWorkflow: true });
    }
    setDataItem((prev) => ({
      ...prev,
      ...result,
      isWorkflow: true,
    }));
  };

  useEffect(() => {
    if (
      userActionType === "Approve" ||
      userActionType === "Decline" ||
      userActionType === "Cancel" ||
      userActionType === "Complete" ||
      userActionType === "Reminder" ||
      userActionType === "Request Review" ||
      userActionType === "Archive" ||
      userActionType === "Un-Archive"
    ) {
      actionsPanelControl();
    }

    if (userActionType === "Reassign") {
      setUserActionType("");
      setModel((prev) => ({ ...prev, showReassignPanel: true }));
    }
    
    if (userActionType === "ReOpen") {
      setUserActionType("");
      setModel((prev) => ({ ...prev, showReOpenPanel: true }));
    }

    if (userActionType.includes("custom")) {
      if (dataItem?.Workflow?.Legacy) {
        // Legacy workflow: use Statuses directly
        let customeStatusName = userActionType.split("custom").pop();
        dataItem?.Workflow?.Statuses?.forEach((s) => {
          if (s.Name.toLowerCase() === customeStatusName.toLowerCase()) {
            setCustomStatusID(s.Id);
            setCustomStatusAction(s.Action);
          }
        });
      } else {
        // Non-legacy workflow: use ActionListItems and look up status from StatusListItems
        let customActionName = userActionType.split("custom").pop();
        dataItem?.Workflow?.ActionListItems?.forEach((action) => {
          if (action.Name.toLowerCase() === customActionName.toLowerCase()) {
            let customStatusName = action.ActionStatus;
            let getStatusId = dataItem?.Workflow?.StatusListItems?.find((status) => status.Name.toLowerCase() == customStatusName.toLowerCase())?.Id;
            setCustomStatusID(getStatusId ?? "");
            setCustomStatusAction(customStatusName ?? "");
            setCustomActionID(action.Id ?? "");
            setCustomActionName(action.Name ?? "");
          }
        });
      }
      setUserActionType("");
      setModel((prev) => ({ ...prev, showCustomStatusPanel: true }));
    }

    switch (dataItem.DocumentTypeId) {
      case 1:
        if (userActionType === "Download Changed Content") {
          setUserActionType("");
          DownloadFile(dataItem.WordDocumentFileId).then((result) =>
            saveAs(result, dataItem.WordDocumentFile)
          );
        }

        if (userActionType === "Download Assigned Content") {
          setUserActionType("");
          DownloadFile(dataItem.WordDocumentFileId).then((result) =>
            saveAs(result, dataItem.WordDocumentFile)
          );
        }

        if (userActionType === "Final Edit" || userActionType === "Edit") {
          setUserActionType("");
          openDocumentCollaborationTask();
        }

        if (
          userActionType === "Updated Document" ||
          userActionType === "Assigned Content" ||
          userActionType === "Changed Content" ||
          userActionType === "Live Document"
        ) {
          viewWordDocument(dataItem.Id, userActionType);
          setDocumentViewerType(userActionType);
          setUserActionType("");
          setModel((prev) => ({ ...prev, showDocumentViewer: true }));
        }
        break;

      case 2:
        if (userActionType === "Final Edit" || userActionType === "Edit") {
          setUserActionType("");
          window.location.href = `${OLD_UI_URL}web/Home/EditExcelWeb/${currentUser.token}/${dataItem.Id}`;
        }

        if (
          userActionType === "Download Assigned Content" ||
          userActionType === "Download Changed Content"
        ) {
          excelDocumentActions(
            dataItem,
            userActionType,
            userID,
            currentUser.token,
            null
          );
          setUserActionType("");
        }

        if (
          userActionType === "Updated Document" ||
          userActionType === "Assigned Content" ||
          userActionType === "Changed Content"
        ) {
          excelDocumentActions(
            dataItem,
            userActionType,
            userID,
            currentUser.token,
            null
          );
          setDocumentViewerType(userActionType);
          setUserActionType("");
          setModel((prev) => ({ ...prev, showDocumentViewer: true }));
        }
        break;

      case 3:
        if (userActionType === "Final Edit" || userActionType === "Edit") {
          setUserActionType("");
          openDocumentCollaborationTask();
        }

        if (
          userActionType === "Updated Document" ||
          userActionType === "Assigned Content" ||
          userActionType === "Changed Content" ||
          userActionType === "Download Changed Content" ||
          userActionType === "Download Assigned Content"
        ) {
          viewPowerpointDocument(dataItem.Id);
          setModel((prev) => ({ ...prev, showDocumentViewerPowerpoint: true }));
        }
        break;

      default:
        //setUserActionType("");
        break;
    }
  }, [userActionType]);

  const actionPanelHideFunction = () => {
    setModel((prev) => ({ ...prev, showActionsPanel: false }));
    setUserActionType("");
    setActionsPanelType("");
  };

  const actionsPanelControl = () => {
    if (userActionType === "Reminder") {
      const { Status } = dataItem.StatusAndButtons;
      if (Status === "Not Started" || Status === "Assigned") {
        setActionsPanelType("Remind Editors to Start Working");
      } else if (Status === "In Progress") {
        setActionsPanelType("Remind Editors to Complete the Task");
      } else if (
        Status === "Awaiting Approval" ||
        Status === "Assigned - Pending review" ||
        Status === "Pending Approval"
      ) {
        setActionsPanelType("Remind Reviewers to Review");
      }
    } else {
      setActionsPanelType(`${userActionType} Task`);
    }
    setModel((prev) => ({ ...prev, showActionsPanel: true }));
  };

  const openStandardTask = (type) => {
    let location = {
      pathname: `/tasks/edit/std/${dataItem.Id}${
        type === "view" ? "/view" : ""
      }`,
    };
    history.push(location);
  };

  const openDocumentCollaborationTask = () => {
    let documentNameT =
      dataItem.Document.DocumentTypeId === 3
        ? dataItem.DocumentFile
        : dataItem.Document.Name;
    if (!documentNameT) {
      documentNameT =
        dataItem.Document.DocumentTypeId === 3
          ? "PowerPointDocument" + dataItem.Document.Id + ".pptx"
          : "WordDocument" + dataItem.Document.Id + ".docx";
    }
    setDocNameForDCTaskModal(documentNameT);
    setModel((prev) => ({ ...prev, showEditDCTaskModal: true }));
  };

  return (
    <>
      <ActionsDropdownNew2
        setUserActionType={setUserActionType}
        auditTrailControl={(open) =>
          setModel((prev) => ({ ...prev, showAuditTrail: open }))
        }
        openTaskHandler={openStandardTask}
        Permission={dataItem.Permission}
        privileges={currentUser.privileges}
        task={dataItem}
        getWorkflowButtons={getWorkflowButtons}
        setDataItem={setDataItem}
        fromTaskEdit={fromTaskEdit}
        taskLabels={labels?.TaskSingular}
      />
      {model.showEditDCTaskModal && (
        <TaskEditDocumentModal
          show={model.showEditDCTaskModal}
          onHide={() => {
            setModel((prev) => ({ ...prev, showEditDCTaskModal: false }));
          }}
          projectId={dataItem.ProjectId}
          documentID={dataItem.Document.Id}
          assignID={dataItem.Id}
          fileName={docNameForDCTaskModal}
          privileges={currentUser.privileges}
        />
      )}
      {model.showDocumentViewer && (
        <DocumentViewer
          task={dataItem}
          document={dataItem.Document}
          title={documentViewerType}
          updatedDocName={dataItem.Document.FileName}
          showDocumentViewer={model.showDocumentViewer}
          //setShowDocumentViewer={setShowDocumentViewer}
        />
      )}
      {model.showDocumentViewerPowerpoint && (
        <DocumentViewerPowerpoint
          assignmentId={dataItem.Id}
          document={dataItem.Document}
          actionType={userActionType}
          showDocumentViewer={model.showDocumentViewerPowerpoint}
          //setShowDocumentViewer={setShowDocumentViewerPowerpoint}
          setUserActionType={setUserActionType}
          statusAndButtons={dataItem?.StatusAndButtons}
        />
      )}
      {model.showReassignPanel && (
        <TasksReassignPanel
          show={model.showReassignPanel}
          onHide={() =>
            setModel((prev) => ({ ...prev, showReassignPanel: false }))
          }
          task={dataItem}
          createdById={dataItem.CreatedById}
          refreshTasks={refreshTasks}
        />
      )}
      {model.showReOpenPanel && (
        <TaskReopenPanel
          show={model.showReOpenPanel}
          onHide={() =>
            setModel((prev) => ({ ...prev, showReOpenPanel: false }))
          }
          task={dataItem}
          type={dataItem.DocumentTypeId === 0 ? "StandardTask" : "DocumentTask"}
          refreshTasks={refreshTasks}
          dateFormatID={currentUser.department.DateFormatID || currentUser.department.dateFormatID}
          labels={labels}
        />
      )}
      {model.showCustomStatusPanel && (
        dataItem?.Workflow?.Legacy 
        ? <TaskCustomStatusPanelLegacy 
            show={model.showCustomStatusPanel}
            onHide={() =>
              setModel((prev) => ({ ...prev, showCustomStatusPanel: false }))
            }
            task={dataItem}
            type={dataItem.DocumentTypeId === 0 ? "StandardTask" : "DocumentTask"}
            refreshTasks={refreshTasks}
            dateFormatID={currentUser.department.DateFormatID || currentUser.department.dateFormatID}
            customStatusID={customStatusID}
            customStatusAction={customStatusAction}
          />
        : <TaskCustomStatusPanel 
            show={model.showCustomStatusPanel}
            onHide={() =>
              setModel((prev) => ({ ...prev, showCustomStatusPanel: false }))
            }
            task={dataItem}
            type={dataItem.DocumentTypeId === 0 ? "StandardTask" : "DocumentTask"}
            refreshTasks={refreshTasks}
            dateFormatID={currentUser.department.DateFormatID || currentUser.department.dateFormatID}
            customStatusID={customStatusID}
            customStatusAction={customStatusAction}
            customActionID={customActionID}
            customActionName={customActionName}
          />
      )}
      {
        <TasksActionsPanelNew
          show={model.showActionsPanel}
          onHide={() => actionPanelHideFunction()}
          type={actionsPanelType}
          task={dataItem}
          button={userActionType === "Reminder" ? "Send" : userActionType}
          refreshTasks={refreshTasks}
          labels={labels}
        />
      }
      {
        <TasksCommentsPanelNew
          task={dataItem}
          assignID={dataItem.Id}
          show={model.showAuditTrail}
          onHide={() =>
            setModel((prev) => ({ ...prev, showAuditTrail: false }))
          }
          type={dataItem.DocumentTypeId === 0 ? "standard" : "document"}
          dateFormatID={currentUser.department.DateFormatID || currentUser.department.dateFormatID}
        />
      }
    </>
  );
};

TaskActions.propTypes = {
  taskId: PropTypes.number.isRequired,
  refreshTasks: PropTypes.func,
  setTaskWorkflow: PropTypes.func,
  fromTaskEdit: PropTypes.bool,
};
